import axios from 'axios';

export const CurrentUserInitializer = async (usersStore, adminStore, userId) => {
    try {
        await usersStore.loadCurrentUser(userId);

        if (usersStore.currentUser.isAdmin) {
            await adminStore.load();
        } else {
            await adminStore.loadEnterprise(userId);
        }

        // Detect and sync browser timezone to user record for timezone-aware emails
        try {
            const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (browserTimezone) {
                await axios.patch(`/users/${userId}`, { timezone: browserTimezone });
            }
        } catch (tzError) {
            console.warn('Failed to sync timezone:', tzError.message);
        }

    } catch (error) {
        if (error.response?.status !== 404) {
            throw error;
        }
    }
};
